	   
var $ = require('jquery');
var _ = require('underscore');
var Azure = EY.Consultation.Lookups.Azure;
var DialogWarning = require('DialogWarning');
var EdwCDALookup = require('EdwCDALookup');
var Labels = EY.Consultation.Labels;


var validation = function () {
    return {
        engagementId: function(){
            return this.get('engagementId').length === 0 ? Labels.ErrorMsg.replace('{0}', Labels.EngagementNumber) :
                (this.get('invalidEngagement') ? Labels.ValidEngagementNumber : '');
        }
    };
};

var invalidEngagement = function (options) {
    options.record.set('invalidEngagement', true);
    DialogWarning.show({
        message: Labels.MSG011
    });
};

module.exports.run = function (options) {
    var record = options.record;
    var engagementId = record.get('engagementId');
    var deferred = $.Deferred();
    var promise = deferred.promise();
    var group = options.group;
    var isEngagementValidationRequired = record.get('validateEngagement') && !record.get('engagementValidated') && group.validateEDW;

    if (!isEngagementValidationRequired) {

        deferred.resolve();
        return promise;
    }
        
    record.validation = _.extend(record.validation || {}, validation());
    EdwCDALookup.getEngagement(engagementId).then(function(result) {

        var isEngagementFound = result && result.length == 1 && result[0].EngagementId == engagementId;

        isEngagementFound && record.set('engagementValidated', true);
        !isEngagementFound && invalidEngagement(options);
        
        deferred.resolve();
    }).catch(function () {

        invalidEngagement(options);
        deferred.resolve();
    });
    
    return promise;
};


// WEBPACK FOOTER //
// ./js/Modules/Record/Service/EdwValidation.js